var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-runner-list"},[(!_vm.isLoading)?_c('RunnerSearch',{attrs:{"runners":_vm.runners}}):_c('div',{staticClass:"loading-message"},[_vm._v(" "+_vm._s(_vm.$t("Please wait, data is loading..."))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }